'use strict'

var Type = require('../type')

module.exports = Type({
  name: 'Forbrugsforeningen',
  pattern: /^600722\d{10}$/,
  eagerPattern: /^600/
})



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/creditcards-types/types/forbrugsforeningen.js
// module id = 7d+y
// module chunks = 0